import api from './api';
import { API_BASE_URL } from '../lib/constants';

/**
 * 创作记录服务
 * 提供创作记录相关的API调用方法
 */
class CreationRecordService {
  
  /**
   * 获取创作记录列表
   * @param {Object} params - 查询参数
   * @param {number} params.page - 页码（从0开始）
   * @param {number} params.size - 每页大小
   * @param {string} params.status - 状态过滤（可选）
   * @returns {Promise} API响应
   */
  async getCreationRecords(params = {}) {
    try {
      const { page = 0, size = 20, status } = params;
      const queryParams = new URLSearchParams({
        page: page.toString(),
        size: size.toString()
      });
      
      if (status && status !== 'all') {
        queryParams.append('status', status.toUpperCase());
      }
      
      const response = await api.get(`/creation-records?${queryParams}`);

      return response.data;
    } catch (error) {
      console.error('获取创作记录失败:', error);
      throw error;
    }
  }

  /**
   * 删除创作记录
   * @param {number} recordId - 记录ID
   * @returns {Promise} API响应
   */
  async deleteCreationRecord(recordId) {
    try {
      const response = await api.delete(`/creation-records/${recordId}`);
      return response.data;
    } catch (error) {
      console.error('删除创作记录失败:', error);
      throw error;
    }
  }

  /**
   * 获取创作记录统计信息
   * @returns {Promise} API响应
   */
  async getCreationStats() {
    try {
      const response = await api.get('/creation-records/stats');
      return response.data;
    } catch (error) {
      console.error('获取统计信息失败:', error);
      throw error;
    }
  }

  /**
   * 下载图片
   * @param {string} imageUrl - 图片URL
   * @param {string} filename - 文件名
   */
  downloadImage(imageUrl, filename) {
    try {
      if (!imageUrl) {
        throw new Error('图片URL不能为空');
      }
      // 使用fetch下载图片并创建blob对象，确保强制下载
      const downloadUrl = imageUrl.startsWith('http') 
        ? imageUrl 
        : `${API_BASE_URL}${imageUrl}`;
      
      fetch(downloadUrl)
        .then(response => response.blob())
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = filename || 'creation-image.png';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(error => {
          console.error('下载图片失败:', error);
          // 如果fetch失败，回退到原来的方法
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = filename || 'creation-image.png';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    } catch (error) {
      console.error('下载图片失败:', error);
      throw error;
    }
  }
}

const creationRecordService = new CreationRecordService();
export default creationRecordService;